<template>
    <v-card tile class="notification" :class="{seen: seen, new: !seen}" v-ripple="ripple" :to="to">
        <div class="d-flex">

            <div class="icon-wrapper ml-4">
                <div class="icon" :class="[
                    color.split(' ')[0] + ' lighten-5',
                    {'dark-theme-icon': isDark}
                ]">
                    <v-icon :color="color + ' darken-1'">{{icon.icon}}</v-icon>
                </div>
                <span class="time x-small-text" :class="{'grey--text': seen, 'font-weight-bold primary--text': !seen}">
                    <v-icon v-show="!seen" size="12" class="primary--text">mdi-flash</v-icon>
                    {{seen ? time : 'جديد'}}
                </span>
            </div>
            <div class="flex-grow notification-details">
                <v-card-title class="title pa-0" :class="titleColor">{{title}}</v-card-title>
                <v-card-subtitle class="content ma-0 pa-0" :class="{'primary--text': !seen}">{{content}}</v-card-subtitle>
            </div>

        </div>
    </v-card>
</template>
<script>
import GlobalComputed from '@/helpers/global-computed'

export default {
    props: ['notification'],
    data(){
        return {
            time: '',
        }
    },
    computed: {
        notificationType(){
            let type = this.notification.data ? this.notification.data.type : null;
            if (!type){
                if (this.notification.type === 'App\\Notifications\\VerifiedNotification'){
                    type = 'verified';
                }else{
                    type = 'default';
                }
            }
            
            return type;
        },
        title(){
            return this.notification.data.title;
        },
        content(){
            return this.notification.data.content;
        },
        icon(){
            if (this.notificationType === 'ticket_reply'){
                return {icon: 'mdi-lifebuoy'};
            }else if (this.notificationType === 'admin_message'){
                return {icon: 'mdi-email'};
            }else if (this.notificationType === 'recharge'){
                return {icon: 'mdi-wallet-plus-outline'};
            }else if (this.notificationType === 'transfer_balance_sent' || this.notificationType === 'transfer_balance_received'){
                return {icon: 'mdi-cash-fast'};
            }
            return {icon: 'mdi-bell'};
        },
        color(){
            if (this.notificationType === 'ticket_reply'){
                return 'purple';
            }else if (this.notificationType === 'admin_message'){
                return 'teal';
            }else if (this.notificationType === 'recharge'){
                return 'green darken-1';
            }else if (this.notificationType === 'transfer_balance_sent'){
                return 'indigo darken-2';
            }else if (this.notificationType === 'transfer_balance_received'){
                return 'green darken-1';
            }
            // return color depanding on notif type
            return 'orange';
        },
        titleColor(){
            return 'strong-text--text';
        },
        ripple(){
            return true;
        },
        to(){
            if (this.notificationType === 'ticket_reply'){
                return {name: 'support'};
            }
            return this.notification.data.to ? this.notification.data.to : null;
            
        },
        seen(){
            return !!this.notification.read;
        },
        ...GlobalComputed
    },
    methods: {
        
        openLink(){
            let id = this.owned ? this.msg.receiver.id : this.msg.sender.id;
            this.$router.push({name: 'profile', params: {id}})
        },

        timeFormat() {
            const self = this;
            let time = this.notification.created_at;

            if (time == 'now') {
                return "الآن";
            }
            
            // Split timestamp into [ Y, M, D, h, m, s ]

            var t = time.split(/[- :]/); // splitting timestamp into array t[], so t[0] is the year .. etc

            // Apply each element to the Date function
            var d = new Date(Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5])); // t[1]-1  -> months starts from 0

            d.setTime(d.getTime());

            var ms = new Date() - d;

            var since = self.timeSince(ms);
            self.time = since;

            // this is to update time every 20s
            this.intervalid1 = setInterval(function () {
                var ms = new Date() - d;

                var since = self.timeSince(ms);
                self.time = since;


            }, 20000);
        },
        timeSince (date) {

            var seconds = Math.floor(date / 1000);

            var interval = Math.floor(seconds / 31536000);

            if (interval >= 1) {
                if (interval == 1) {
                    return "عام واحد";
                } else if (interval == 2) {
                    return "عامين";
                } else if (interval <= 10) {
                    return "" + interval + " أعوام";
                } else {
                    return "" + interval + " عام";
                }
            }


            interval = Math.floor(seconds / 2592000);
            if (interval >= 1) {
                if (interval == 1) {
                    return "شهر واحد";
                } else if (interval == 2) {
                    return "شهرين";
                } else if (interval <= 10) {
                    return "" + interval + " شهور";
                } else {
                    return "" + interval + " شهر";
                }
            }


            interval = Math.floor(seconds / 86400);
            if (interval >= 1) {
                if (interval == 1) {
                    return "يوم واحد";
                } else if (interval == 2) {
                    return "يومين";
                } else if (interval <= 10) {
                    return "" + interval + " أيام";
                } else {
                    return "" + interval + " يوم";
                }
            }


            interval = Math.floor(seconds / 3600);
            if (interval >= 1) {
                if (interval == 1) {
                    return "ساعة واحدة";
                } else if (interval == 2) {
                    return "ساعتين";
                } else if (interval <= 10) {
                    return "" + interval + " ساعات";
                } else {
                    return "" + interval + " ساعة";
                }
            }


            interval = Math.floor(seconds / 60);
            if (interval >= 1) {
                if (interval == 1) {
                    return "دقيقة واحدة";
                } else if (interval == 2) {
                    return "دقيقتين";
                } else if (interval <= 10) {
                    return "" + interval + " دقائق";
                } else {
                    return "" + interval + " دقيقة";
                }

            }

            return "الآن";

        },
    },
    mounted(){
        this.timeFormat();
    }
    
}
</script>
<style lang="scss" scoped>
    .notification{
        box-shadow: none!important;
        border-bottom: 1px solid #eee;
        padding: 1rem;
        user-select: none;
        &.theme--dark{
            border-bottom: 1px solid var(--v-surface2-base);
        }
        &.seen{
            opacity: 0.9;
            // filter: grayscale(0.3);
        }
        &.new{
            opacity: 1;
            .content{
                color: #000!important;
                font-size: 13.5px;
                font-weight: 500;
            }
        }
        .title{
            font-size: 1rem!important;
            line-height: 1.5rem;
            word-break: normal;
            font-weight: 500;
            margin-bottom: 0.2rem!important;
            cursor: default;
        }
        .content{
            font-size: 13px!important;
            cursor: default;
            user-select: none;
        }
        .icon-wrapper{
            display: flex;
            align-items: center;
            flex-direction: column;
            .time{
                //margin-top: 12px;
                line-height: 20px;
            }
            .icon{
                width: 58px;
                height: 58px;
                border-radius: 50%;
                overflow: hidden;
                background-color: #efefef;
                display: flex;
                justify-content: center;
                align-items: center;
    
                &.default-bg{
                    background-color: #faeec4!important;
                }
                &.dark-theme-icon {
                    background: var(--v-surface2-base) !important;
                    border: thin solid var(--v-surface2-base) !important;
                }
            }
        }
    }
</style>